import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { ProductsPage } from "./pages/ProductsPage";
import { ContactPage } from "./pages/ContactPage";
import { Toaster } from "./components/ui/sonner";
import { WhatsAppIcon } from "./components/WhatsAppIcon";
import { LanguageModal } from "./components/LanguageModal";
import { ScrollToTop } from "./components/ScrollToTop";
import { ProductProvider } from "./context/ProductContext";

const openWhatsApp = () => {
  window.open('https://wa.me/917702099393?text=' + encodeURIComponent('Hello Stigmaflora! I would like to know more about your products.'), '_blank', 'noopener,noreferrer');
};

function App() {
  return (
    <div className="App">
      <ProductProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
        
        {/* Floating WhatsApp Button */}
        <button
          onClick={openWhatsApp}
          data-testid="floating-whatsapp"
          className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform cursor-pointer"
          title="Chat on WhatsApp"
        >
          <WhatsAppIcon className="w-8 h-8 text-white" />
        </button>
        
        {/* Language Selection Modal */}
        <LanguageModal />
      </BrowserRouter>
      </ProductProvider>
    </div>
  );
}

export default App;
